import { showUserAlert } from "../utils/userErrorMessage";
import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import { supabase } from "../supabase/client";

export default function MaintenanceViewPage() {
  const [maintenanceList, setMaintenanceList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [search, setSearch] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [editedProceedings, setEditedProceedings] = useState({});

  const company = localStorage.getItem("email") || "";

  useEffect(() => {
    const fetchData = async () => {
      if (!company) {
        setMaintenanceList([]);
        setFilteredList([]);
        return;
      }
      const { data, error } = await supabase
        .from("maintenance")
        .select("*")
        .eq("company", company)
        .order("date", { ascending: false });

      if (error) {
        console.error("고장신고 데이터 불러오기 실패:", error.message);
      } else {
        setMaintenanceList(data);
        setFilteredList(data);
      }
    };

    fetchData();
  }, [company]);

  const handleFilter = () => {
    const lowerSearch = search.toLowerCase();
    const filtered = maintenanceList.filter((item) => {
      const dateMatch =
        (!dateFrom || item.date >= dateFrom) &&
        (!dateTo || item.date <= dateTo);
      const searchMatch =
        item.driver_name?.toLowerCase().includes(lowerSearch) ||
        item.detail?.toLowerCase().includes(lowerSearch) ||
        item.car_number?.toLowerCase().includes(lowerSearch) ||
        item.date?.includes(search);
      return dateMatch && searchMatch;
    });

    setFilteredList(filtered);
  };

  const handleChange = (id, value) => {
    setEditedProceedings((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSaveAll = async () => {
    const updates = Object.entries(editedProceedings).map(([id, proceeding]) => ({
      id,
      proceeding,
    }));

    const updatePromises = updates.map((entry) =>
      supabase
        .from("maintenance")
        .update({ proceeding: entry.proceeding })
        .eq("id", entry.id)
        .eq("company", company)
    );

    await Promise.all(updatePromises);
    showUserAlert("진행상황 저장 완료!");
    setEditedProceedings({});
  };

  return (
    <div className="space-y-1">    
      <style>{`
        .maintenance-table th,
        .maintenance-table td {
          text-align: center;
        }

        .maintenance-table .col-detail,
        .maintenance-table .col-status {
          text-align: left;
        }
      `}</style>
      <Header />
        <div className="px-4 pt-1 pb-4">
        <h2 className="text-xl font-bold mb-4">고장 신고 내역</h2>

        {/* 🔍 검색 필터 */}
        <div className="flex flex-wrap gap-2 md:gap-4 items-center mb-4">
            <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className="border p-2"
            placeholder="From"
            />
            <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="border p-2"
            placeholder="To"
            />
            <input
            type="text"
            placeholder="기사명, 차번호, 신고내역, 날짜 검색"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border p-2 flex-grow min-w-0"
            />
            <button onClick={handleFilter} className="bg-blue-500 text-white px-4 py-2">검색</button>
        </div>

        {/* 📋 테이블 */}
        <div className="overflow-x-auto">
            <table className="maintenance-table w-full border border-gray-300">
            <thead>
                <tr className="bg-gray-100">
                <th className="border px-2 py-1">날짜</th>
                <th className="border px-2 py-1 col-detail">신고내역</th>
                <th className="border px-2 py-1">기사명</th>
                <th className="border px-2 py-1 hidden md:table-cell">차번호</th>
                <th className="border px-2 py-1 hidden md:table-cell">마일리지</th>
                <th className="border px-2 py-1 col-status">진행상황</th>
                </tr>
            </thead>
            <tbody>
                {filteredList.map((item) => (
                <tr key={item.id}>
                    <td className="border px-2 py-1 mobile-maintenance-cell" data-label="날짜">{item.date}</td>
                    <td className="border px-2 py-1 col-detail mobile-maintenance-cell" data-label="신고내역">{item.detail}</td>
                    <td className="border px-2 py-1 mobile-maintenance-cell" data-label="기사명">{item.driver_name}</td>
                    <td className="border px-2 py-1 hidden md:table-cell">{item.car_number}</td>
                    <td className="border px-2 py-1 hidden md:table-cell">{item.mileage}</td>
                    <td className="border px-2 py-1 col-status mobile-maintenance-cell" data-label="진행상황">
                    <input
                        type="text"
                        value={editedProceedings[item.id] ?? item.proceeding ?? ""}
                        onChange={(e) => handleChange(item.id, e.target.value)}
                        className="border px-1 py-1 w-full"
                    />
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>

        {/* 💾 전체 저장 버튼 */}
        <div className="mt-4 text-right">
            <button
            onClick={handleSaveAll}
            className="bg-green-600 text-white px-6 py-2 rounded"
            >
            전체 저장
            </button>
        </div>
        </div>
    </div>
  );
}
